module.exports = __webpack_public_path__ + "static/media/social-facebook.5e74f5e6.svg";